
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0/Types.js";
import { list_type, option_type, union_type, class_type, record_type, string_type } from "../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { TimePoint_$reflection } from "./Forecast.js";

export class Waypoint extends Record {
    constructor(Reference, TimePoint) {
        super();
        this.Reference = Reference;
        this.TimePoint = TimePoint;
    }
}

export function Waypoint_$reflection() {
    return record_type("StenaWeather.Domain.Sessions.Waypoint", [], Waypoint, () => [["Reference", string_type], ["TimePoint", TimePoint_$reflection()]]);
}

export class VoyageId extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SessionId", "MergedSessionId"];
    }
}

export function VoyageId_$reflection() {
    return union_type("StenaWeather.Domain.Sessions.VoyageId", [], VoyageId, () => [[["Item", class_type("System.Guid")]], [["Item1", class_type("System.Guid")], ["Item2", class_type("System.Guid")]]]);
}

export function VoyageId__get_MainSessionId(this$) {
    if (this$.tag === 1) {
        return this$.fields[0];
    }
    else {
        return this$.fields[0];
    }
}

export class SessionBasicInfo extends Record {
    constructor(SessionId, VesselId, Created, Deleted, FirstTimePoint, LastTimePoint) {
        super();
        this.SessionId = SessionId;
        this.VesselId = VesselId;
        this.Created = Created;
        this.Deleted = Deleted;
        this.FirstTimePoint = FirstTimePoint;
        this.LastTimePoint = LastTimePoint;
    }
}

export function SessionBasicInfo_$reflection() {
    return record_type("StenaWeather.Domain.Sessions.SessionBasicInfo", [], SessionBasicInfo, () => [["SessionId", class_type("System.Guid")], ["VesselId", class_type("System.Guid")], ["Created", class_type("System.DateTimeOffset")], ["Deleted", option_type(class_type("System.DateTimeOffset"))], ["FirstTimePoint", option_type(class_type("System.DateTime"))], ["LastTimePoint", option_type(class_type("System.DateTime"))]]);
}

export class VoyageInfo extends Record {
    constructor(VoyageId, VesselId, Created, Deleted, LastTimePoint, Route) {
        super();
        this.VoyageId = VoyageId;
        this.VesselId = VesselId;
        this.Created = Created;
        this.Deleted = Deleted;
        this.LastTimePoint = LastTimePoint;
        this.Route = Route;
    }
}

export function VoyageInfo_$reflection() {
    return record_type("StenaWeather.Domain.Sessions.VoyageInfo", [], VoyageInfo, () => [["VoyageId", VoyageId_$reflection()], ["VesselId", class_type("System.Guid")], ["Created", class_type("System.DateTimeOffset")], ["Deleted", option_type(class_type("System.DateTimeOffset"))], ["LastTimePoint", option_type(class_type("System.DateTime"))], ["Route", option_type(list_type(Waypoint_$reflection()))]]);
}

